<template>
    <div>
        <kgr-loading v-if="loading" />
        <kgr-empty-data
            v-if="empty && !loading"
            :value="$t('Keine Daten vorhanden')"
        />
        <div
            v-if="!empty"
            class="chart"
        >
            <highcharts :options="chartOptions" />
        </div>
        <div>
            <kgr-button
                v-if="!loading"
                :disabled="jobRunning"
                @click="createUpdateJob"
            >
                {{ $t('Aktualisieren') }}
            </kgr-button>
            <span v-if="jobRunning">{{ $t('Die Daten werden im Hintergrund berechnet. Die Grafik aktualisiert sich sobald die Daten verfügbar sind.') }}</span>
        </div>
    </div>
</template>

<script>
import ClubStatsRepository from '../../js/repository/ClubStatsRepository';
import EmptyData from '../common/EmptyData';
import KgrButton from '../common/form/button/KgrButton';
import Loading from '../common/Loading';

export default {
    name: 'KgrDepartmentMemberAllocation',
    components: {
        'kgr-empty-data': EmptyData,
        'kgr-loading': Loading,
        'kgr-button': KgrButton,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        activeMemberCount: {
            type: Number,
            required: true,
            default: 0,
        }
    },
    data() {
        return {
            empty: true,
            loading: true,
            jobRunning: false,
            chartOptions: {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie'
                },
                title: {
                    text: this.$t('Verteilung der {num} Mitglieder auf die Abteilungen', { 'num': this.activeMemberCount}),
                },
                tooltip: {
                    pointFormat: '<span class="kgr-text--bold">{point.y}</span> ' +
                        this.$t('Mitglieder') +
                        '<br><span class="kgr-text--bold">{point.percentage:.1f} %</span>'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: false,
                        },
                        showInLegend: true
                    }
                },
                series: [{
                    name: '',
                    colorByPoint: true,
                    data: []
                }],
                credits: {
                    enabled: false
                },
                legend: {
                    align: 'right',
                    layout: 'vertical',
                    verticalAlign: 'top',
                    y: 15,
                    itemStyle: {
                        fontWeight: 'var(--kgr-font-weight-bold)',
                    }
                },
            }
        }
    },
    mounted() {
        this.loadRunningJob();
    },
    methods: {
        loadDepartmentMemberAllocation() {
            ClubStatsRepository.getDepartmentMemberAllocation(this.clubId)
                .then(stats => {
                    this.empty = stats.length === 0;
                    this.loading = false;
                    this.chartOptions.series[0].data = stats.map(entry => {
                        return {
                            name: entry.name,
                            y: entry.membersCount,
                        };
                    });
                });
        },
        loadRunningJob() {
            ClubStatsRepository.getDepartmentMemberAllocationJob(this.clubId)
                .then(response => {
                    this.jobRunning = response.isRunning;
                    if (this.jobRunning === false) {
                        this.loadDepartmentMemberAllocation();
                    }
                }).finally(() => {
                    if(this.jobRunning === true) {
                        setTimeout(() => {
                            this.loadRunningJob();
                        },
                        1000
                        )
                    }
                });
        },
        createUpdateJob() {
            ClubStatsRepository.putDepartmentMemberAllocationJob(this.clubId)
                .then(() => {
                    this.jobRunning = true;
                    this.loadRunningJob();
                });
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .chart {
        margin: 0 auto;
    }
</style>
